<template>
    <div v-if="data.show" :id="data.stepId">
    <div v-if="data.id == 18" :class="active == data.id ? 'create_offer_top item active' : 'create_offer_top item'" @click="path">
        <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M7.5 0C7.76522 0 8.01957 0.105357 8.20711 0.292893C8.39464 0.48043 8.5 0.734784 8.5 1V6H13.5C13.7652 6 14.0196 6.10536 14.2071 6.29289C14.3946 6.48043 14.5 6.73478 14.5 7C14.5 7.26522 14.3946 7.51957 14.2071 7.70711C14.0196 7.89464 13.7652 8 13.5 8H8.5V13C8.5 13.2652 8.39464 13.5196 8.20711 13.7071C8.01957 13.8946 7.76522 14 7.5 14C7.23478 14 6.98043 13.8946 6.79289 13.7071C6.60536 13.5196 6.5 13.2652 6.5 13V8H1.5C1.23478 8 0.98043 7.89464 0.792893 7.70711C0.605357 7.51957 0.5 7.26522 0.5 7C0.5 6.73478 0.605357 6.48043 0.792893 6.29289C0.98043 6.10536 1.23478 6 1.5 6H6.5V1C6.5 0.734784 6.60536 0.48043 6.79289 0.292893C6.98043 0.105357 7.23478 0 7.5 0Z" fill="#A4ADEB"/>
        </svg>
        <h3>{{ $t( data.title) }}</h3>
    </div>
    <div v-else :class="active == data.title ? 'item active' : 'item'" @click="path">
        <img :src="data.img" alt="">
        <h3>{{ $t( data.title) }}</h3>
        <svg v-if="data.subscription != 'free'" width="9" height="8" viewBox="0 0 9 8" fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style="width: 13px;height: 13px;margin-left: 10px;margin-top: 2px;">
            <path
                d="M0.777064 1.04341L2.55721 2.56592L4.1432 0.667779C4.18761 0.614714 4.24376 0.572071 4.30748 0.543026C4.37119 0.513982 4.44083 0.499284 4.5112 0.500027C4.58157 0.50077 4.65087 0.516935 4.71392 0.547318C4.77697 0.577701 4.83216 0.621519 4.87537 0.67551L6.38885 2.56547L8.22653 1.02112C8.2987 0.960599 8.38816 0.922946 8.48295 0.913201C8.57774 0.903457 8.67332 0.922086 8.75692 0.966597C8.84051 1.01111 8.90813 1.07937 8.95071 1.16226C8.9933 1.24515 9.00882 1.3387 8.9952 1.4304L8.29344 6.13574H0.717648L0.00512243 1.45177C-0.00903114 1.35957 0.00631304 1.26536 0.0490766 1.18191C0.0918401 1.09846 0.159956 1.0298 0.2442 0.985237C0.328443 0.940671 0.424743 0.92235 0.520056 0.932754C0.615369 0.943159 0.705089 0.981786 0.777064 1.04341ZM0.75414 6.59049H8.23963V7.04525C8.23963 7.16585 8.19034 7.28152 8.10261 7.36681C8.01487 7.45209 7.89587 7.5 7.77179 7.5H1.22198C1.0979 7.5 0.978906 7.45209 0.891168 7.36681C0.80343 7.28152 0.75414 7.16585 0.75414 7.04525V6.59049Z"
                fill="#FEF3C7" />
        </svg>
    </div>
</div>
</template>

<script>
import { EventBus } from "../../../admin/offer/components/EventBus.js";

export default {
    props: ['data','active', 'paid_type', 'is_blog'],
    methods: {
        path() {
            // polozky s 'action' neroutuju — otvaraju modal cez event bus
            if (this.data.action) {
                EventBus.$emit(this.data.action);
                return;
            }
            window.location.href = this.data.paths[0];
        }
    },
}
</script>

<style lang="scss" scoped>
.menuleft, .menuleftmobile{
    &.hide{
        .item{
            width: 95%;
            justify-content: center;
            padding-left: 0;
            img{
                margin: 0;
            }
            h3{
                display: none;
            }
        }
    }
    .create_offer_top.item{
        background: #292E52;
        border-radius: 8px;
        h3{
            margin-left: 10px;
        }
    }
    .item{
        transition: .3s all;
        width: 90%;
        height: 44px;
        display: flex;
        align-items: center;
        padding-left: 18px;    
        margin: 5px auto;
        cursor: pointer;
        @media only screen and (max-width: 1370px) {
            height: 38px;
            margin: 4px auto;
        }
        &:hover{
            background: rgba(255, 255, 255, 0.14);
            border-radius: 6px;
        }
        &.active{
            background: rgba(255, 255, 255, 0.14);
            border-radius: 6px;
        }
        h3{
            transition: .8s all;    
            font-family: Montserrat;
            font-style: normal;
            font-weight: 600;
            font-size: 16px;
            line-height: 20px;
            color: #FFFFFF;  
            margin: 0;
            @media only screen and (max-width: 1370px) {
                font-size: 14px;
            }
        }
        img{
            transition: .5s all;
            margin-right: 12px;
        }
    }
}
</style>